import TheProduct from '@elem/compPage/amazon-sale';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

const whiteLocaleList = ['jp'];

export default function Page({ SEO, lang, systemTime }: any) {
    const { locale = 'jp' } = useRouter();
    const { t } = useLang('amazonsale');

    return (
        <PageLayout isNoFixed>
            <SEO title={lang.seo_title || t('seo_title')} description={lang.seo_desc || t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="amazon-sale" />
            <TheProduct systemTime={systemTime} />
        </PageLayout>
    );
}

const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd' || process.env.NEXT_PUBLIC_MODY === 'staging'; //是否是生产环境
export async function getServerSideProps({ locale, query }: any) {
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    const { _timer } = query;
    // 时间节点判断 正式环境未开始重定向404
    let systemTime = new Date().getTime(); // 系统时间
    const startTime = new Date('2024-08-30 14:00:00 GMT+8').getTime(); // 开始时间;
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }
    // 系统时间不在上述时间段,且进入生产环境才跳转404
    if (systemTime < startTime && isPrd) {
        return redirectTo404();
    }
    return {
        props: { systemTime },
    };
}
